import { PencilSimpleLine } from "@phosphor-icons/react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { typedObjectEntries } from "common/helpers/utils";

import { useCampaignContext } from "../../../context/CampaignContext";
import { getFormattedInterval } from "../../../utils";

export default function ScheduleReview() {
  const {
    schedule: { timezone: _timezone, ...campaignSchedule },
  } = useCampaignContext();

  return (
    <section className="rounded-3xl border border-black-200 lg:col-span-2">
      <div className="flex justify-between gap-4 border-b border-black-200 p-3 max-lg:items-center">
        <div>
          <h5 className="mb-0.5 text-button-md">Sending Schedule</h5>
          <p className="text-xs text-black-500">
            The time your audience should receive deliveries from this campaign
          </p>
        </div>

        <Button intent="iconOnly" variant="secondary-black" asChild>
          <Link to="../schedule">
            <PencilSimpleLine />
          </Link>
        </Button>
      </div>

      <div className="flex flex-col p-3">
        {typedObjectEntries(campaignSchedule).map(([day, { intervals }]) => (
          <div
            key={day}
            className={clsx(
              "flex items-center border-b border-black-200 py-3 first:pt-0 last:border-b-0 last:pb-0",
              !intervals.length && "text-black-400",
            )}
          >
            <h6 className="capitalize">{day}</h6>

            <div className="ml-auto flex flex-col items-end">
              {intervals.length
                ? intervals.map((interval) => {
                    const { startValue, endValue } =
                      getFormattedInterval(interval);

                    return (
                      <span key={interval.end} className="text-sm-bold">
                        {startValue} - {endValue}
                      </span>
                    );
                  })
                : "Not active"}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
